import { render, staticRenderFns } from "./ShareInfo.vue?vue&type=template&id=70d15eb8&scoped=true"
import script from "./ShareInfo.vue?vue&type=script&lang=js"
export * from "./ShareInfo.vue?vue&type=script&lang=js"
import style0 from "./ShareInfo.vue?vue&type=style&index=0&id=70d15eb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d15eb8",
  null
  
)

export default component.exports